import { useEffect } from "react";
import { useSelector } from "react-redux";
import { axiosPrivate } from "../../../core/api/http-common";
import useRefreshToken from "./useRefreshToken";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const reqIntercept = axiosPrivate.interceptors.request.use((config) => {
      if (!config.headers.Authorization && auth?.accessToken) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`;
      }
      return config;
    });

    const resIntercept = axiosPrivate.interceptors.response.use(
      (res) => res,
      async (error) => {
        const prev = error.config;

        if (!error.response) {
          return Promise.reject(error); // réseau / backend down
        }

        // 🔁 uniquement token expiré
        if (error.response.status === 401 && !prev.sent) {
          prev.sent = true;

          try {
            const newToken = await refresh();

            prev.headers.Authorization = `Bearer ${newToken}`;
            return axiosPrivate(prev);
          } catch (err) {
            return Promise.reject(err);
          }
        }

        // ❌ 403 = accès refusé → pas de refresh
        if (error.response.status === 403) {
          // ici tu peux logout ou afficher une page unauthorized
          return Promise.reject(error);
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axiosPrivate.interceptors.request.eject(reqIntercept);
      axiosPrivate.interceptors.response.eject(resIntercept);
    };
  }, [auth, refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
